// Stores the active tenant ID after profile load.
// Sent as X-Tenant-Id on every API request so downstream services
// can scope data without re-parsing the JWT.

let activeTenantId: string | null = sessionStorage.getItem('tenant-id');

export function getTenantId(): string | null {
  return activeTenantId;
}

export function setTenantId(id: string | null): void {
  activeTenantId = id;
  if (id) {
    sessionStorage.setItem('tenant-id', id);
  } else {
    sessionStorage.removeItem('tenant-id');
  }
}
